import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { SvgIconComponent } from 'angular-svg-icon';


@Component({
    selector: 'que-upload-file',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateDirective, TranslatePipe, SvgIconComponent],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: UploadFileComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: UploadFileComponent,
            multi: true
        }
    ],
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadFileComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  @Output() focusEvent = new EventEmitter<boolean>();

  #builder = inject(FormBuilder);

  questionForm = this.#builder.group({
    isIconUploadFile: new FormControl<boolean>(false),
    allowMultipleFiles: new FormControl<boolean>(false)
  });

  orginalQuestion?: Question;

  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  ngOnInit(): void {
    this.questionForm.valueChanges.subscribe(question => {
      this.registerOnChangeCallback({
        ...this.orginalQuestion,
        definitions: {
          ...this.orginalQuestion?.definitions,
          isIconUploadFile: question.isIconUploadFile,
          allowMultipleFiles: question.allowMultipleFiles
        }
      });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }

  writeValue(obj: Question): void {
    this.orginalQuestion = obj;
    this.questionForm.patchValue(
      {
        isIconUploadFile: obj.definitions?.isIconUploadFile,
        allowMultipleFiles: obj.definitions?.allowMultipleFiles
      },
      { emitEvent: false });
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  markIconUploadFile(what: boolean) {
    this.questionForm.controls.isIconUploadFile.setValue(what);
  }
  markMultipleFiles(value: boolean) {
    this.questionForm.controls.allowMultipleFiles.setValue(value);
  }
}
